import React, { ReactNode } from "react";
import { type ChartConfig, ChartProvider } from "./ChartContext"
  
function defineChartColorVariables(config: ChartConfig) {
  if (typeof document === "undefined") return {}

  const style: Record<string, string> = {}

  Object.entries(config).forEach(([key, value]) => {
    style[`--color-${key}`] = value.color
  })

  return style
}

interface ChartContainerProps {
  children: ReactNode
  config: ChartConfig
  className?: string
}

export function ChartContainer({ children, config, className = "" }: ChartContainerProps) {
  const colorVariables = defineChartColorVariables(config)

  return (
    <ChartProvider config={config}>
      <div className={`w-full ${className}`} style={colorVariables}>
        {children}
      </div>
    </ChartProvider>
  )
}
